import { IPublicClientApplication } from "@azure/msal-browser";
import axios from "axios";
import {
    axiosDelRequest,
    axiosGetRequest,
    axiosPatchRequest,
    axiosPostRequest,
} from "../../api/ApiClient";
import GenericUtils from "../../utils/GenericUtils";
import { UserRole } from "../../model/Enums/UserRoleEnum";

type Type = "UPLOAD" | "DOWNLOAD";

const route = "/docente/v1/funcionalidades";

async function getSystemFeatures(msalInstance: IPublicClientApplication) {
    return axiosGetRequest(
        `${route}`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function getImportedDocuments(msalInstance: IPublicClientApplication) {
    return axiosGetRequest(
        `${route}/helps`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function getImportedDocumentByFeatureId(
    msalInstance: IPublicClientApplication,
    featureId: UserRole | null
) {
    return axiosGetRequest(
        `${route}/${featureId}/helps`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function deleteImportedDocumentByFeatureId(
    msalInstance: IPublicClientApplication,
    featureId: UserRole | null
) {
    return axiosDelRequest(
        `${route}/${featureId}/helps`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function getFileUrl(
    msalInstance: IPublicClientApplication,
    featureId: UserRole | null,
    fileName: string | undefined,
    type: Type
) {
    return axiosGetRequest(
        `${route}/${featureId}/file?fileName=${fileName}&fileAction=${type}`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function createHelp(
    msalInstance: IPublicClientApplication,
    featureId: UserRole | null,
    fileName: string | undefined
) {
    const body = {
        fileName,
        funcionalidadeId: featureId,
    };

    return axiosPostRequest(
        `${route}/helps`,
        body,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function updateHelp(
    msalInstance: IPublicClientApplication,
    helpId: number,
    featureId: UserRole | null,
    fileName: string | undefined
) {
    const body = {
        id: helpId,
        fileName,
        funcionalidadeId: featureId,
    };

    return axiosPatchRequest(
        `${route}/${featureId}/helps`,
        body,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function uploadFileByUrl(url: string, file: File | undefined) {
    return axios.put(`${url}`, file, {
        headers: {
            "x-ms-blob-type": "BlockBlob",
        },
    });
}

export default {
    getSystemFeatures,
    getImportedDocuments,
    getImportedDocumentByFeatureId,
    deleteImportedDocumentByFeatureId,
    getFileUrl,
    createHelp,
    updateHelp,
    uploadFileByUrl,
};
